<div class="remember-password">
  <header><button class="close"
            (click)="visibility.next(false)"></button></header>
  <div class="image"></div>
  <h3 class="title">{{ 'forgot_password' | translate }}</h3>
  <p class="subtitle">{{ 'forgot_password_subtitle' | translate }}</p>
</div>
